<template>
<div class="container container--narrow pdt-50 mgb-50">
	<div v-if="groupQuestionCount === 1">
		<question-tag
			:avgSolveTime="question.avgSolveTime"
			:correctRate="question.avgSolveTime"
			:level="paperLevel"
		></question-tag>
				<div class="mgt-16 t-subtitle6 t-line-h-28 font-rn">
					<vue-mathjax v-if="question.useMathjax" :formula="question.contents.text"></vue-mathjax>
					<div v-else>
						{{ question.contents.text }}
					</div>
				</div>
					<div v-if="question && question.contents && question.contents.image" class="mgt-24">
						<img :src="question.contents.image" alt="" class="b-radius4 ">
				</div>
				<div class="mgt-24">
						<label :id="`answerEl${question.id}`"
										class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "  data-mdc-auto-init="MDCTextField">
										<span class="mdc-notched-outline">
											<span class="mdc-notched-outline__leading"></span>
											<span class="mdc-notched-outline__notch">
												<span id="my-label-id" class="mdc-floating-label">{{$t('1254')}}</span>
											</span>
											<span class="mdc-notched-outline__trailing"></span>
										</span>
										<input @input="updateText" :value="text" autocomplete="off"
										 class="mdc-text-field__input cursor-blue"
											maxlength="1000"
											type="text"
											@keyup="setAnswer"
											/>
										<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" role="button"
														tabindex="0">report_problem</i>
						</label>
				</div>
			</div>
			<div v-else>
					<div v-if="index === 0" class="mgt-16 t-body1 t-line-h-28 ">
						{{groupQuestionTitle}}
					</div>
					<div class="mgt-24">
						<div class="mdc-card pda-24 bg-documentGray position-relative">
							<question-tag
								class="mgb-16"
								:avgSolveTime="question.avgSolveTime"
								:correctRate="question.avgSolveTime"
								:level="paperLevel"
							></question-tag>
							<div class="t-subtitle6 font-rn t-line-h-26">
								<vue-mathjax v-if="question.useMathjax" :formula="question.contents.text"></vue-mathjax>
								<div v-else>
									{{ question.contents.text }}
								</div>
							</div>
							<div v-if="question && question.contents && question.contents.image" class="mgt-24">
									<img :src="question.contents.image" alt="" class="b-radius4">
							</div>
							<div class="mgt-24">
								<label :id="`answerEl${question.id}`"
									class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "  data-mdc-auto-init="MDCTextField">
									<span class="mdc-notched-outline">
										<span class="mdc-notched-outline__leading"></span>
										<span class="mdc-notched-outline__notch">
											<span id="my-label-id" class="mdc-floating-label">{{$t('1254')}}</span>
										</span>
										<span class="mdc-notched-outline__trailing"></span>
									</span>
									<input @input="updateText" :value="text" autocomplete="off"
										class="mdc-text-field__input cursor-blue"
										maxlength="50"
										type="text"
										@keyup="setAnswer"
										/>
									<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" role="button"
													tabindex="0">report_problem</i>
								</label>
							</div>
						</div>
					</div>
				</div>
		<question-tip v-if="question.tip" :marginType="groupQuestionCount === 1 ? true :false" :tip="question.tip"/>
</div>
</template>

<script>
/**
 * 단일답안 문항 컴포넌트(short answer type question component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import QuestionTag from './QuestionTag.vue'
import QuestionTip from './QuestionTip.vue'
import {questionMixin} from '@/mixins/question.js'
export default {
	props: ['question', 'groupQuestionCount', 'groupQuestionTitle', 'currentQuestionCheckStatus', 'setedAnswer', 'paperLevel', 'index'],

  data() {
		return {
			text: '',
			isSolve: false,
		}
	},

	components: {
		'question-tag': QuestionTag,
		'question-tip': QuestionTip,
	},

	mixins: [questionMixin],

	mounted() {
		const textField = new MDCTextField(document.querySelector(`#answerEl${this.question.id}`))
		this.text = this.setedAnswer.text
		this.isSolve = this.setedAnswer.isSolve
		this.solveTime = this.setedAnswer.solveTime || 0
		textField.value = this.text
		this.startTimer()
	},

	updated() {
		const textField = new MDCTextField(document.querySelector(`#answerEl${this.question.id}`))
		textField.value = this.text
	},

	watch: {
		 // currentQuestionCheckStatus에 따라 타이머 동작(currentQuestionCheckStatus timer action)
		currentQuestionCheckStatus: function(value) {
			if(!value) {
				this.startTimer()
			} else {
				this.clearTimer()
			}
		}
	},

	methods: {
		shortRange() {
      this.setAnswer()
    },

		//답안정보 설정 및 부모 컴포넌트에 전달(Answer information setting and delivery to parent component)
		setAnswer() {
			if (this.text) {
				this.isSolve = true
			} else {
				this.isSolve = false
			}
			this.currentQuestionCheckTrueFalse()
      this.checkIsChecked()
		},

		currentQuestionCheckTrueFalse() {
      this.$emit('checkCurrentQuestionStatus')
    },

		checkIsChecked() {
      let params = this.setParam()
      this.$emit('checkIsCheckeds', params)
      const debouncedSetAnswers = _.debounce(() => {
        this.$emit('setAnswers', params);
      }, 500);
      debouncedSetAnswers();
    },

		// 파라미터 설정(set parameter)
		setParam() {
			let params = {
				questionId: this.question.id,
				text: this.text,
				selected: [],
				texts: [],
				startDate: this.startDate,
				solveTime: this.solveTime,
				isSolve: this.isSolve,
				groupId: this.question.groupId,
			}
			return params
		},

		// v-model 제거 후 @input으로 변경
		updateText(e) {
			this.text = e.target.value;
		}
	}
}
</script>
